import { Field, OptionSheet } from '@relay-towing/ui';
import { useNavigate } from 'react-router-dom';
import { useUserCompanies } from '../../hooks/useUserCompanies';
import { setNativeCompany } from '../../lib/nativeBridge';

/**
 * Which company the app is showing, for someone in more than one: in the
 * presence menu, beside the duty status, where a wrong company is noticed.
 * It was at the bottom of Settings, and an owner looking at another
 * company's empty Functions took it for missing pages. Nothing for someone
 * in one company.
 */
export function CompanyField({ onSwitched }: { onSwitched?: () => void }) {
  const navigate = useNavigate();
  const { companies, selectedCompanyId, selectCompany } = useUserCompanies();
  if (companies.length < 2) return null;

  const switchCompany = async (companyId: string) => {
    if (companyId === selectedCompanyId) return;
    await selectCompany(companyId);
    onSwitched?.();
    // The wrapper reloads into the new company itself; a browser starts the
    // new company at Home, not on a screen from the old one.
    if (!setNativeCompany(companyId)) navigate('/', { replace: true });
  };

  return (
    <Field label="Company">
      <OptionSheet
        title="Company"
        options={companies.map(({ company }) => ({
          value: company.id,
          label: company.name,
        }))}
        value={selectedCompanyId ?? undefined}
        onValueChange={switchCompany}
      />
    </Field>
  );
}
